// src/components/Common/Moodle/Learning/MoodleLearningAdapter.ts

import { LearningCourseModel, LearningItemType, LearningNavItem, LearningSection } from '../../Learning/types';
import { computeRequiredProgressFromSections } from './MoodleLearningProgress';

function mapModuleType(modname?: string): LearningItemType {
  switch (modname) {
    case 'page':
      return 'page';
    case 'lesson':
      return 'lesson';
    case 'quiz':
      return 'quiz';
    case 'resource':
      return 'resource';
    case 'url':
      return 'url';
    case 'label':
      return 'label';
    case 'folder':
      return 'folder';
    case 'forum':
      return 'forum';
    default:
      return 'unknown';
  }
}

export function buildMoodleLearningModel(params: {
  courseId: string;
  courseTitle: string;
  sections?: any[];
}): LearningCourseModel {
  const { courseId, courseTitle, sections = [] } = params;

  const normalizedSections: LearningSection[] = sections.map((section: any, sectionIndex: number) => {
    const items: LearningNavItem[] = (section.modules || [])
      .filter((mod: any) => mod?.visible !== false)
      .filter((mod: any) => mod?.uservisible !== false)
      .filter((mod: any) => mod?.modname !== 'label')
      .map((mod: any, itemIndex: number) => {
        const isRequired = !!mod.completiondata?.hascompletion;
        const isComplete = !!mod.completiondata?.isoverallcomplete;

        return {
          id: String(mod.id),
          provider: 'moodle',
          title: mod.name || `${mod.modname || 'Item'} ${mod.id}`,
          type: mapModuleType(mod.modname),
          sectionId: String(section.id),
          sectionTitle: section.name || `Section ${sectionIndex + 1}`,
          order: sectionIndex * 1000 + itemIndex,
          isComplete,
          isRequired,
          visible: mod.visible !== false && mod.uservisible !== false,
          raw: mod,
        };
      });

    return {
      id: String(section.id),
      title: section.name || `Section ${sectionIndex + 1}`,
      order: sectionIndex,
      items,
    };
  });

  const items = normalizedSections.flatMap((section) => section.items);

  const progress = computeRequiredProgressFromSections(sections);

  return {
    provider: 'moodle',
    courseId,
    title: courseTitle,
    sections: normalizedSections.filter((section) => section.items.length > 0),
    items,
    progress: {
      completed: progress.completed,
      total: progress.total,
      percent: progress.percent,
    },
  };
}